<template>
  <vs-popup id="popupMultiPrintViewer" title="선택 후 인쇄" :active.sync="showPopup">
    <div class="popup-multi-print-viewer">
      <div class="left" v-if="showPopup" style="overflow-x: auto">
        <table-list-page
          :board-id="boardId"
          :board-slug="`board-${boardId}`"
          :download="false"
          :create="false"
          :approval="isApproval"
          :move-project="false"
          :move-detail="false"
          :nav="popupNav"
          :heads="heads"
          :getCol="getCol"
          :query-search-mode="false"
          :select-list="printDatas"
          :list-theme="listTheme"
          :min-width="minWidth"
          @load="onLoadData"
          @detail="onClickDetail"
          @selectAll="onSelectAll"
          @selectPrint="onClickPrint"
        >
          <template #search>
            <component :is="searchComponent" :options="searchOption" :value="popupNav.value" @input="onChangeSearch" />
          </template>
        </table-list-page>
      </div>
      <input type="hidden" id="isPrint" value="false" />
      <input type="hidden" id="hidePrintTitle" value="false" />
      <div id="popup-print-report">
        <template v-for="(form, i) in printDatas">
          <component
            :key="`print-component-${i}`"
            :is="componentWrite"
            :class="{'print-break-page' : !isApproval}"
            :board="{
              projectTitle: '',
              writer: {}, //작성자 정보
              readonly: true, // 읽기전용인가
              isPrint: true,
              viewSaveBtn: false,
            }"
            :is-print="true"
            :value="getContent(form)"
            :postId="form.id"
          />
          <approval-process-module
            v-if="isApproval"
            :key="`print-approvalLine-${i}`"
            class="print-break-page"
            :board="boards[i]"
            :isPrint="true"
            :show-approval-time="true"
            :style="{ display: 'block', height: 'auto !important' }"
          ></approval-process-module>
        </template>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import draggable from "vuedraggable";
import SearchNav from "@/components/nav/SearchNav";
import tabItems from "@/views/boards/tab/tab-items";
import singlePageList from "@/views/boards/single-page/listIndex";
import TableListPage from "@/views/list/TableListPage";
import singlePageWrite from "@/views/boards/single-page/writeIndex";
import moment from "moment";
import write845 from "@/views/boards/single-page/845/Write.vue";
import ApprovalProcessModule from "@/views/modules/ApprovalProcessModule.vue";

export default {
  components: {ApprovalProcessModule, TableListPage, SearchNav, draggable, write845 },
  props: {
    value: Boolean,
    isApproval: Boolean,
    boardId: [Number, String],
    searchComponent: Object,
    searchOption: Object,
    nav: Object,
    method: Object,
    // 목록 페이지(tab-items 의 listTheme/minWidth)와 같은 테마·열 너비로 그린다. 없으면 TableListPage 기본값(origin)
    listTheme: { type: String, default: "origin" },
    minWidth: Number,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.printDatas = [];
        }
        this.$emit("input", value);
      },
    },

    componentWrite() {
      // TODO: 이후 원인파악 및 수정방법 을 알게 될 경우 수정해야함.
      // tab/writeIndex.js 에서 모듈화 시키는 과정에서
      // singlePageWrite['845_write'] 의 값이 undefined 가 되는 현상이 있어
      // 예외처리로 직접 import 한 write845 컴포넌트를 반환하도록 수정함
      if (`${this.boardId}` === '845') {
        return 'write845';
      }
      return singlePageWrite[`${this.boardId}_write`];
    },

    heads() {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getHead();
      }
      return [];
    },
  },
  watch: {
    nav(value) {
      this.popupNav = value;
    },
    // 부모(tab/Index.vue)는 nav 객체를 교체하지 않고 nav.projectId 만 채우기 때문에
    // 위의 nav watch 가 호출되지 않아 popupNav.projectId 가 0으로 남는다.
    // (0 이 전달되면 List.js 의 getConditions 등에서 다른 프로젝트 기준으로 조회됨)
    // 팝업의 projectId 는 현재 라우트의 proj_id 를 기준으로 직접 맞춰준다.
    "$route.params.proj_id": {
      immediate: true,
      handler(value) {
        this.popupNav.projectId = value || 0;
      },
    },
  },
  data() {
    return {
      tabItems,
      printDatas: [],
      boards: [],
      isPrint: false,
      popupNav: {
        projectId: 0,
        orderTarget: "created_at",
        orderDirection: "desc",
        date: { year: new Date().getFullYear(), month: "" },
        value: {},
        page: {},
        keyword: [],
      },
    };
  },
  methods: {
    getCol(index, value) {
      const func = {
        getContent: this.getContent,
        getCreatedDate: this.getCreatedDate,
        getCompanyName: this.getCompanyName,
        getContentTargetList: this.getContentTargetList,
        onNameBlur: this.onNameBlur,
        getContentRiskList: this.getContentRiskList,
        getContentStringList: this.getContentStringList,
        comma: this.comma,
      };
      const listInfo = singlePageList[`${this.boardId}_list`];

      if (listInfo) {
        const __getCol = (index, value, func) => {
          const head = listInfo.getHead()[index];
          const keys = head.key.split(".");

          const keysLength = keys.length;
          if (keysLength === 1) {
            if (keys[0] === "created_at") {
              return func.getCreatedDate(value.created_at);
            }
          }

          if (keysLength > 1) {
            const content = JSON.parse(value.post_content);
            const getData = (keys) => {
              let data = content;
              for (let i = 0; i < keys.length; i++) {
                data = data[keys[i]];
              }
              return data;
            };
            return getData(keys);
          }
        };

        if (listInfo.getCol) {
          return listInfo.getCol(index, value, {
            ...func,
            _getCol: __getCol,
          });
        } else {
          const data = __getCol(index, value, func);
          if (Array.isArray(data)) {
            return data.join(", ");
          }
          return data;
        }
      }
      return "";
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    getCreatedDate(data) {
      if (data === "") return "";
      return moment(data).format("YYYY-MM-DD");
    },
    getCompanyName(comId) {
      for (const com of this.listCompanyList) {
        if (com.id === comId) {
          return com.com_name;
        }
      }
    },
    getContentTargetList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    onNameBlur(name) {
      const length = name.length;
      if (length > 2) {
        const first = name[0];
        const last = name[name.length - 1];
        let star = "";
        for (let index = 0; index < length - 2; index++) {
          star += "*";
        }
        name = first + star + last;
      } else if (length === 2) {
        const first = name[0];
        name = `${first}*`;
      }
      return name;
    },
    getContentRiskList(list) {
      let result = "";
      for (const data of list) {
        if (data.input_3) {
          if (typeof data.input_3 === "string") {
            if (!result.includes(data.input_3)) {
              result += `${data.input_3},`;
            }
          }

          if (typeof data.input_3 === "object") {
            const temp = data.input_3.toString().split(",");
            for (const t of temp) {
              if (t && !result.includes(t)) {
                result += `${t},`;
              }
            }
          }
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentStringList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data)) {
          result += `${data},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    handleClickClose() {
      this.showPopup = false;
    },

    onChangeSearch(value) {
      this.popupNav.value = value;
    },

    onLoadData(data) {},

    async onSelectAll(list) {
      const boardId = this.boardId;
      for (const data of list) {
        const postId = data.postId;
        if (!postId) {
          continue;
        }
        const findIndex = this.printDatas.findIndex((item) => item.id === postId);
        if (findIndex > -1) {
          continue;
        }
        if (this.isApproval) {
          await this.loadApprovalPost(`board-${boardId}`, postId);
        } else {
          await this.loadBoardPost(boardId, postId);
        }
      }
    },
    onClickDetail(data) {
      const boardId = this.boardId;
      const postId = data.postId;
      const findIndex = this.printDatas.findIndex((item) => item.id === postId);
      if (findIndex > -1) {
        this.onClickDelete(findIndex, postId);
        return;
      }

      if (this.isApproval) {
        this.loadApprovalPost(`board-${boardId}`, postId);
      } else {
        this.loadBoardPost(boardId, postId);
      }
    },

    onClickDelete(id, postId) {
      this.printDatas.splice(id, 1);
    },

    async loadBoardPost(boardId, postId) {
      await this.$store.dispatch("board/LOAD_POST", {
        boardId,
        postId,
      });

      // 내용
      const post = this.$store.state.board.postInfo;
      this.docProjectId = post.project_id;

      if (post.post_content) {
        const form = JSON.parse(post.post_content);
        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }
        form.body.createdAt = post.created_at;

        this.printDatas.push(post);
      }
    },
    async loadApprovalPost(boardSlug, postId) {
      let post = {};
      await this.$store.dispatch("approval/LOAD_POST", { boardSlug, postId }).then((value) => {
        console.log("value", value)
        post = value.post;
        this.docProjectId = post.project_id;
        this.__LOAD_POST(value)
        return value;
      });

      if (!this.$store.state.approval.postInfo) {
        alert("열람 권한이 없습니다.");
        this.oldForm = JSON.parse(JSON.stringify(this.form));
        this.onMoveNormalPage("list");
        return;
      }
      // 내용
      if (post.post_content) {
        const form = JSON.parse(post.post_content);

        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }

        // enc 내용을 본문에 추가하기
        // form = this.loadApprovalPostContent(form);
        // this.form = form;
      }

      // TODO : 결재프로세스
      const doc = this.$store.state.approval.document;
      this.docInfo = doc;
      this.docInfo.slug = this.boardSlug;

      this.printDatas.push(post);
    },

    onClickPrint() {
      const tab = this.tabItems[Number(`${this.boardId}`)];
      if (tab.printDirection === "portrait") {
        return this.printPortrait();
      }
      if (tab.printDirection === "landscape") {
        return this.printLandscape();
      }

      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },

    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    /**
     * 사진대지처럼 이미지의 용량이 큰 경우, 인쇄가 안되는 경우가 있어서
     * 다음과 같은 처리를 해준다.
     * 새로운 창을 연 후, DOMContentLoaded 이벤트가 발생하면, 현재 창에서 출력하고자 하는 내용을 새로운 창으로 넘겨준다.
     * 이 후, load 이벤트가 발생하면, 새로운 창에서 인쇄를 실행한다.
     * >> DOMContentLoaded : DOM 트리가 완성되면 호출됨
     * >> load : 모든 리소스가 로드되면 호출됨 (이미지가 모두 로딩된 후 호출됨)
     */
    print(css) {
      // 프린트
      this.isPrint = true;

      const winPrint = window.open(this.$route.fullPath, "_blank");
      winPrint.addEventListener("DOMContentLoaded", () => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");
          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }
        const isPrint = document.getElementById("isPrint").value === "true";
        const hidePrintTitle = document.getElementById("hidePrintTitle").value === "true";

        const g_label = document.getElementById("print-label") && this.usePrintTitle ? document.getElementById("print-label").innerHTML : "";
        document.getElementById("popup-print-report").style.display = "block";
        const g_oBeforeBody = document.getElementById("popup-print-report").innerHTML;
        winPrint.document.body.style.backgroundColor = "#fff";
        winPrint.document.body.innerHTML = "";
        if (g_label && isPrint && !hidePrintTitle) {
          winPrint.document.body.innerHTML += `${g_label}<br>`;
        }
        winPrint.document.body.innerHTML += g_oBeforeBody;
        winPrint.document.body.style.padding = "16px";

        const head = winPrint.document.head || winPrint.document.getElementsByTagName("head")[0],
          style = winPrint.document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(winPrint.document.createTextNode(css));
        }
        head.appendChild(style);
      });
      winPrint.addEventListener("load", function () {
        winPrint.print();
      });

      winPrint.onbeforeprint = function () {
        document.getElementById("popup-print-report").style.display = "none";
      };
      winPrint.onafterprint = function () {
        document.getElementById("popup-print-report").style.display = "none";
      };
      winPrint.onbeforeunload = function () {
        document.getElementById("popup-print-report").style.display = "none";
      };
    },

    __LOAD_POST(data) {
      const state = {
        postInfo: {},
        postAfters: [],
        document: {},
      }

      if (!data.post) {
        state.postInfo = null;
        return;
      }

      const status = data.document_status;
      const user = data.user;
      state.postInfo = data.post;
      state.postAfters = data.approved_afters;

      state.document = {
        id: data.id, //상신문서 번호
      };

      // 문서상태 등록됨/진행중
      if (status) {
        state.document.status = {
          id: status.id,
          code: status.code,
          name: status.name,
        };
      }

      // 문서작성자 정보, postInfo.actor와 동일한 정보
      if (user) {
        const company = user.company;
        state.document.writer = {
          id: user.id,
          name: user.name,
          company_id: user.company_id,
          rank: user.rank,
          department: user.department,
          position: user.position,
          section: user.section,
        };
        if (company) {
          state.document.writer.company_name = company.com_name;
        }
        if (user.virtual_company) {
          state.document.writer.virtual_company = user.virtual_company;
        }
      }

      // 작성대상자선택
      const postData = JSON.parse(data.post.post_content).body;
      const lvs = Object.keys(postData)
        .filter((key) => key.startsWith("selectLV"))
        .reduce((acc, key) => {
          acc[key] = postData[key];
          return acc;
        }, {});

      // 결재라인
      const lines = data.line_elements;
      const list = [];
      let turnApprovalId = 0;
      for (const line of lines) {
        const user = line.element_user;
        const status = line.element_status;
        const type = line.element_type;
        const member = {
          user_id: user ? user.id : 0,
          user_name: user ? user.name : `{삭제된 사용자}`,
          status_id: status.id,
          status_code: status.code,
          status_name: status.name,
          type_id: type.id,
          type_code: type.code,
          type_name: type.name,
          comments: line.comments,
          updated_at: line.updated_at,
          rank: (user && user.rank) || "",
          department: (user && user.department) || "",
          position: (user && user.position) || "",
          section: (user && user.section) || "",
          line
        };
        if (line.document_company_id) {
          member.document_company_id = line.document_company_id;
          member.document_company_code = line.document_company.virtual_company.code || "";
        }

        if (user && user.company) {
          member.company_id = user.company.id;
          member.company_name = user.company.com_name;
        } else {
          member.company_id = 0;
          member.company_name = "";
        }

        // 결재자 ID 저장 (첫번째 wait)
        if (member.type_code === "approval" && member.status_code === "wait" && turnApprovalId === 0) {
          turnApprovalId = member.user_id;
        }

        list.push(member);
      }

      // 처리부서 처리
      if (data.approval_document_companies) {
        state.document.approval_document_companies = data.approval_document_companies;
      }

      state.document.turn_approval_id = turnApprovalId;
      state.document["line"] = list;

      console.log("state", state)
      const doc = state.document;
      const board = this.__SetBoard(doc, {});
      this.boards.push(board)
    },

    __SetBoard(doc, _board) {
      const board = JSON.parse(JSON.stringify(_board));
      board.slug = doc.slug;
      board.statusCode = doc.status.code;
      board.writer = doc.writer;
      board.turnApprovalId = doc.turn_approval_id;
      board.isWriter = false;
      board.isTurnApproval = false;
      board.readonly = true;

      // 처리부서를 처리한다
      if (doc && doc.approval_document_companies && Array.isArray(doc.approval_document_companies) && doc.approval_document_companies.length > 0) {
        for (const company of doc.approval_document_companies) {
          if (!company || !company.virtual_company) continue;

          if (company.element_type === "결재") {
            if (!board.documentCompany) {
              board.documentCompany = {
                document_company_id: company.id || null,
                virtual_company_id: company.virtual_company.id || null,
                id: Array.isArray(company.virtual_company.full_code) ? company.virtual_company.full_code.join("\\") : "",
                code: company.virtual_company.code || "",
                label: company.virtual_company.com_name || "",
                full_label: company.virtual_company.full_name || "",
              };
            }
          } else if (company.element_type === "참조") {
            if (!board.referenceCompanies) {
              board.referenceCompanies = [];
            }

            if (board.referenceCompanies.find(item => item.document_company_id === company.id)) {
              continue;
            }
            board.referenceCompanies.push({
              document_company_id: company.id || null,
              virtual_company_id: company.virtual_company.id || null,
              id: Array.isArray(company.virtual_company.full_code) ? company.virtual_company.full_code.join("\\") : "",
              code: company.virtual_company.code || "",
              label: company.virtual_company.com_name || "",
              full_label: company.virtual_company.full_name || "",
            });
          }
        }
      }

      board.resend = board.isWriter && board.statusCode === "rejected";
      board.isCompleteApproval = board.statusCode === "approved" || board.statusCode === "rejected";

      board.savable = board.statusCode === "temp";
      board.collection = board.isWriter && board.statusCode === "registered";

      // 모듈 표기용
      board.approvalLine = doc.line.slice();

      return board
    },
  },
};
</script>
<style scoped lang="scss">
.popup-multi-print-viewer {
  display: grid;
  /* grid-template-columns: 1fr 270px; */
}
#popup-print-report,
#print-preview {
  display: none;
}
</style>
<style lang="scss">
#popupMultiPrintViewer.con-vs-popup {
  z-index: 53000;

  .vs-popup {
    width: 1300px !important;
    height: auto;

    position: relative;
  }
  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}

#subCard {
  .vx-card__collapsible-content.vs-con-loading__container,
  .vx-card__collapsible-content.vs-con-loading__container > .vx-card__body {
    height: 100%;
  }
}

.print-card {
  display: grid;
  grid-template-columns: 16px 1fr;

  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  .handle {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background: rgba(var(--vs-secondary), 1);
  }
}
.print-card-body {
  padding-left: 0.75rem;
  font-size: 0.8rem;
}

.print-break-page {
  page-break-after: always;
}
</style>
